import React, { useRef, useState,useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button,Input, Space, Table ,Modal,Popconfirm,Form, Select, message} from 'antd';
import Highlighter from 'react-highlight-words';
import { useNavigate } from 'react-router-dom';
import { getReviewerList } from 'api/journalservice';
import { getJournalList } from 'api/journalservice';
import { createReviewer } from 'api/journalservice';
import { deleteReviewer } from 'api/journalservice';
//import 'css/issues.css' ;

const Issues = () => {

  const [loading, setLoading] = useState(false);
  const { Option } = Select;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const [data, setData] = useState([]);
  const [isMount, setIsMount] = useState(false);
  const [journals, setJournals] = useState([]);
    
  useEffect(() => {
    //fetch data from api
    if (isMount) {
      setLoading(true); 
      getReviewerList().then((result) => {
        const rawData = Array.isArray(result?.data) ? result.data : [];
  
        const safeData = rawData
          .filter(item => item && typeof item === 'object') 
          .map((item) => ({
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            journals: item.journals,
            id: item.reviewerId

          }));
  
        setData(safeData); 
      })
      .finally(() => {
      setLoading(false); 

      });

    }
  }, [isMount]);

  useEffect(()=>{
    setIsMount(true)
    
  }, []) 
  
  useEffect(() => {
    if (isModalOpen) {

      getJournalList().then((response) => {
        const rawData = Array.isArray(response?.data) ? response.data : [];
        setJournals(rawData);
      });
    }
  }, [isModalOpen]);

  const navigate = useNavigate();

  

  const handleActionClick = (event,record) => {
    navigate(`./article_actions/${record.id}`);

  };
  
  const columns = [
    {
      title: 'Year',
      dataIndex: 'Year',
      key: 'Year',
     

    },
    {
      title: 'Volume',
      dataIndex: 'Volume',
      key: 'Volume',

    },
    {
      title: 'Number',
      dataIndex: 'Number',
      key: 'Number',
      
    },

    {
      title: 'From(month)',
      dataIndex: 'From',
      key: 'From',

    },
  
    {
      title: 'To(month)',
      key: 'To',

    },
    {
      title: 'Is Current',
      key: 'isCurrent',

    },
    {
      title: 'Maximum Page Count',
      key: 'maxPageCount',

    },
    {
      title: 'Cover Image',
      key: 'coverImage',

    },
    {
      title: 'Article Count',
      key: 'articleCount',

    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
              <Space size="middle">
                <Button
                  type="primary"
                  onClick={() => handleEdit(record)}
                  className="action-btn edit-btn"
                  ghost
                >
                  Edit
                </Button>
                <Popconfirm
                  title="Are you sure you want to delete this reviewer?"
                  onConfirm={() => handleDelete(record)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button className="action-btn delete-btn" danger ghost>
                    Delete
                  </Button>
                </Popconfirm>
               
              </Space>
            ),
    },
    
    
  ];
  const handleEdit = (record) => {

    navigate(`./edit_reviewer/${record.id}`);
  };
  
  const handleDelete = (record) => {
  deleteReviewer(record.id)
    .then((result) => {
      message.success("Reviewer Deleted Successfully");

      // بارگذاری دوباره داده‌ها بعد از حذف
      getReviewerList().then((result) => {
        const rawData = Array.isArray(result?.data) ? result.data : [];

        const safeData = rawData
          .filter(item => item && typeof item === 'object')
          .map((item) => ({
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            journals: item.journals,
            id: item.reviewerId
          }));

        setData(safeData);
      });

    })
    .catch((error) => {
      console.error("Error Deleting Reviewer!", error);
      message.error("Error Deleting Reviewer!");
    });
  };

  const handleFinish = async (values) => {
    try {
      // ارسال دیتا به سرور
      const response = await createReviewer(values);
      
      if (response?.result?.result === true) {
        message.success('Reviewer added successfully');
        setIsModalOpen(false);
        form.resetFields();

            // بعد از اضافه شدن، دیتا رو دوباره بگیر
        const result = await getReviewerList();
        const rawData = Array.isArray(result?.data) ? result.data : [];

        const safeData = rawData
          .filter(item => item && typeof item === 'object')
          .map((item) => ({
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            journals: item.journals,
            id : item.id
          }));

        setData(safeData); 


      }
      else {
        message.error('Failed to add reviewer');
      }
    } catch (error) {
      console.error('Error submitting reviewer:', error);
      message.error('There was an error adding the reviewer');
    }
  };
  return (
    
    <>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
        <Button className="add-new-btn" onClick={showModal}>
          + Add New Issue
        </Button>
      </div>
      <Modal
        title="Add New Issue"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
        >
          <Form.Item
            label="First Name"
            name="firstName"
            rules={[{ required: true, message: 'Please enter first name' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Last Name"
            name="lastName"
            rules={[{ required: true, message: 'Please enter last name' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, type: 'email', message: 'Enter a valid email' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Journal"
            name="journal"
            rules={[{ required: true, message: 'Please select at least one journal' }]}
            >
            <Select placeholder="Select a journal" mode="multiple">
              {journals.map((journal) => (
                <Option key={journal} value={journal.id}>
                  {journal.title}
                </Option>
              ))}
            </Select>
          </Form.Item>

        

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Table 
        columns={columns} 
        dataSource={data} 
        loading={loading}
        rowKey="id" 
        onRow={(record) => ({
          style: { cursor: 'pointer' }, 
          
        })} 
        rowClassName={() => 'custom-row-hover'} 

      />

    </>
  );
 

};

export default Issues;
